/**
 * Send one mutation through the registered Relay environment and answer with
 * its data.
 *
 * The counterpart to `genQuery`: Relay's `useMutation` is a hook, and a client
 * module is not a component, so this is how a mutation is sent from one. What
 * it adds over `commitMutation` is a promise, which is what a caller that
 * awaits its mutation and handles a failure in a `catch` reads.
 *
 * The store records what came back, so a mutation returning a record updates
 * every component reading it.
 */import{commitMutation}from"relay-runtime";import{currentRelayEnvironment}from"web/shared/relay/environment";// The last mutation sent under each serialization key, so the next one with
// that key waits for it. Relay deduplicates and pools queries, but it has no
// notion of two mutations that must not overlap, and that is a guarantee the
// client gives on purpose: two operations co-creating one backend identity
// race each other, and the client is where that race would originate.
//
// Keyed, not global: different keys run at the same time, because serializing
// every mutation would make an unrelated save wait behind a translation.
const sending=new Map();/**
 * The data a mutation answered with.
 *
 * Rejects with the GraphQL errors' messages joined into one; a request that
 * produced no answer at all rejects with what the transport raised.
 */export function genMutate(mutation,variables,options){var _sending$get;const key=options===null||options===void 0?void 0:options.serializationKey;if(key==null){return _genSent(mutation,variables);}// Chained onto whatever holds the key, and onto its failure too: a mutation
// that failed still had its turn, and the next one must not be stranded
// behind it.
const held=(_sending$get=sending.get(key))!==null&&_sending$get!==void 0?_sending$get:Promise.resolve();const next=held.then(()=>_genSent(mutation,variables),()=>_genSent(mutation,variables));// What is remembered never rejects, so keeping a failure does not turn it
// into an unhandled rejection.
sending.set(key,next.then(()=>undefined,()=>undefined));return next;}function _genSent(mutation,variables){return new Promise((resolve,reject)=>{commitMutation(currentRelayEnvironment(),{mutation,variables,onCompleted:(response,errors)=>{if(errors!=null&&errors.length>0){reject(new Error(errors.map(error=>error.message).join("; ")));return;}resolve(response);},onError:error=>{reject(error);}});});}